module.exports = __webpack_public_path__ + "static/media/1023533.b8f2260f.png";